import { useSwrFetch } from "./useSwrFetch";

export function useShipmentRoute(routeId: number | undefined) {
  const url = routeId !== undefined ? `/routes/${routeId}` : null;

  const { data, loading, error, refetch } = useSwrFetch<GetRouteResponse>({
    url,
    errorMessage: "Failed to fetch route",
  });

  let route: Route | null = null;
  if (data != null) {
    route = {
      id: data.route.id,
      type: data.route.type,
      route_points: data.points || [],
      created_at: data.route.created_at,
      navigation: data.navigation ?? null,
    };
  }

  return {
    route,
    error,
    loading,
    refetchRoute: refetch,
  };
}
